/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlSeverity9 = {
    Informational: 'INFORMATIONAL',
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Critical: 'CRITICAL'
} as const;
export type ControlSeverity9 = typeof ControlSeverity9[keyof typeof ControlSeverity9];


export function ControlSeverity9FromJSON(json: any): ControlSeverity9 {
    return ControlSeverity9FromJSONTyped(json, false);
}

export function ControlSeverity9FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSeverity9 {
    return json as ControlSeverity9;
}

export function ControlSeverity9ToJSON(value?: ControlSeverity9 | null): any {
    return value as any;
}

